import { render, staticRenderFns } from "./EquipmentList.vue?vue&type=template&id=471a57c5&scoped=true"
import script from "./EquipmentList.vue?vue&type=script&lang=js"
export * from "./EquipmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a57c5",
  null
  
)

export default component.exports